import React, {Component} from 'react';

import {pickBetween}  from '../utils/color';



class Legend extends Component {
  render() {
    const {height, width, steps, color, theme_colors } = this.props;

    let blocks = [];  
    if (steps.length !== 0){
      blocks = [...Array(steps.length - 1).keys()].map((i) => {
        return (<div 
          className={"block"}
          key={"_id"+i}
          style={{backgroundColor: pickBetween(color, i, 0, steps.length - 1), width: width, height: height, display: 'inline-block'}}
          />)
        });    
    }

    const labels = steps.map((step, i) => (<div 
      className={"label"} 
      key={"_id"+i}
      style={{width, display: 'inline-block', fontSize: '12px', textAlign: "center", color: theme_colors.text, fontWeight: 'normal'}}>
        {step['formatted']}
      </div>)
    );

    return (
      <div className={"legend"}>
        <div style={{padding: `0 20px`}}>{blocks}</div>
        <div>{labels}</div>
      </div>
    );
  }
}

export default Legend;
